import styled from 'styled-components';

export default styled.hr`
  border-top: none;
  border-color: #606060;
  width: 100%;
`;
